import React from 'react'
import Link from 'gatsby-link'
import Image from 'gatsby-image'
import { navigateTo } from 'gatsby-link'
import styled from 'styled-components'
import BlogHeader from '../components/blog/header'
import Slide from 'react-reveal/Slide'
import { HelmetDatoCms } from 'gatsby-source-datocms'

const PageWrapper = styled.div`
  .featured-article {
    margin: 4rem 0;

    @media screen and (max-width: 768px) {
      display: flex;
      flex-direction: column;

      .featured-content {
        order: 2;
        flex-basis: unset;
      }
    }
  }
  .featured-content {
    padding: 3rem;
    flex-direction: column;
    justify-content: center;

    @media screen and (max-width: 768px) {
      padding: 1rem;
    }
  }

  .divider {
    max-width: 1200px;
    margin: auto auto;
  }

  .list-article {
    @media screen and (max-width: 768px) {
      margin: 2rem 0;
    }
  }
`

const Blog = ({ data }) => (
  <PageWrapper>
    <HelmetDatoCms seo={data.datoCmsBlogPage.seoMetaTags} />
    <BlogHeader />
    <article className="featured-article columns">
      <div className="column is-hidden-tablet">
        <h1 className="title has-text-dark ">Featured</h1>
      </div>
      <div className="featured-content is-flex column is-half">
        <p className="has-text-primary">
          {data.datoCmsBlogPage.featured.publishDate}
        </p>
        <Link to={'/blog/' + data.datoCmsBlogPage.featured.slug} className="">
          <h2 className="title is-marginless is-size-3 has-text-dark is-uppercase has-text-weight-bold">
            {data.datoCmsBlogPage.featured.title}
          </h2>
        </Link>
        <p className="has-text-dark">
          {data.datoCmsBlogPage.featured.excerpt}
          {'...'}
          <Link
            to={'/blog/' + data.datoCmsBlogPage.featured.slug}
            className="has-text-primary has-text-weight-bold"
          >
            read more.
          </Link>
        </p>
      </div>
      <div className="column is-half">
        {/* <img src={data.datoCmsBlogPage.featured.image.url} alt="" /> */}
        <Link to={'/blog/' + data.datoCmsBlogPage.featured.slug}>
          <Slide right delay={500} fraction={0.5}>
            <Image sizes={data.datoCmsBlogPage.featured.image.sizes} />
          </Slide>
        </Link>
      </div>
    </article>
    <hr className="divider" />
    <div className="section container">
      <div className="columns">
        <div className="column ">
          {data.allDatoCmsBlog.edges.map(blog => {
            return (
              <article
                className="list-article columns is-multiline"
                key={blog.node.id}
              >
                <div className="column is-one-third-desktop is-12-tablet">
                  <Link to={'/blog/' + blog.node.slug} className="image is-4x3">
                    {/* <img src={blog.node.image.url} alt="" /> */}
                    <Image sizes={blog.node.image.sizes} />
                  </Link>
                </div>
                <div className="column is-two-thirds-desktop is-12-tablet">
                  <div className="">
                    <p className="has-text-primary">{blog.node.publishDate}</p>
                    <Link to={'/blog/' + blog.node.slug} className="">
                      <h2 className="title is-marginless is-size-3 has-text-dark is-uppercase has-text-weight-bold">
                        {blog.node.title}
                      </h2>
                    </Link>
                    <p className="has-text-dark">
                      {blog.node.excerpt}
                      {'...'}
                      <Link
                        to={'/blog/' + blog.node.slug}
                        className="has-text-primary has-text-weight-bold"
                      >
                        read more.
                      </Link>
                    </p>
                  </div>
                </div>
              </article>
            )
          })}
        </div>
        {/* <div className="column is-one-third"> */}
        {/*   <h4 className="title has-text-dark">Recommended Posts</h4> */}
        {/*   <hr /> */}
        {/* </div> */}
      </div>
    </div>
  </PageWrapper>
)

export default Blog

export const BlogListQuery = graphql`
  query BlogListQuery {
    datoCmsBlogPage {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      featured {
        id
        slug
        publishDate(formatString: "MMMM DD")
        title
        image {
          url
          sizes(maxWidth: 1600) {
            ...GatsbyDatoCmsSizes
          }
        }
        excerpt
        content
      }
    }
    allDatoCmsBlog(sort: { fields: [publishDate], order: DESC }) {
      edges {
        node {
          id
          slug
          publishDate(formatString: "MMMM DD")
          title
          image {
            url
            sizes(maxWidth: 1600) {
              ...GatsbyDatoCmsSizes
            }
          }
          excerpt
          content
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/blog.js